module.exports = __webpack_public_path__ + "static/media/191212162233721.d6cbce7c.jpg";